import { BrandLockup } from "./BrandLockup";

export const PodcastFooter = () => {
  return (
    <footer
      className="w-full px-0 mt-10"
      style={{ background: "rgba(255,255,255,.05)", borderTop: "1px solid rgba(255,255,255,.08)" }}
    >
      <div className="max-w-xl mx-auto px-5 sm:px-6 py-6">
        <p className="font-bold text-white text-[15px]">Acerca de este podcast</p>
        <p className="text-white/60 text-[13px] leading-relaxed mt-2">
          El Medio de Medios te ofrece cada mañana un resumen con análisis y contexto de los temas que marcan la
          agenda informativa. Nuevo episodio todos los días.
        </p>

        <div className="flex items-center gap-3 mt-6 flex-wrap">
          <BrandLockup size="sm" className="bg-white/95 rounded-lg px-2.5 py-1.5" />
          <p className="text-white/60 text-[12px] leading-snug">
            Una producción conjunta de <span className="text-white font-semibold">Nuestra Visión TV</span> e{" "}
            <span className="text-white font-semibold">Intelite</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
